var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LitElement, html } from 'lit';
import { property, state } from 'lit/decorators.js';
import { qboui } from './styles.js';
class QboTabs extends LitElement {
    static { this.styles = [
        qboui
    ]; }
    constructor() {
        super();
        this.activeIndex = 0;
        this.tabs = [];
        //tabs: Tab[] = [
        //    { title: 'Doc 1', render: html`<qbo-document type="summary" apiendpoint="api://qbo4/documents/document/summary/${'20145'}"></qbo-document>`, key: 1 },
        //    { title: 'Doc 2', render: html`<qbo-document type="summary" apiendpoint="api://qbo4/documents/document/summary/130134"></qbo-document>`, key: 2 },
        //];
        this.listener = null;
        this.handleAddTab = (event) => {
            const { title, render, focus = true } = event.detail;
            if (title && render) {
                this.tabs = [...this.tabs, { title, render, key: Date.now() }];
            }
            if (focus)
                this.setActiveTab(this.tabs.length - 1);
        };
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.listener)
            document.addEventListener(this.listener, this.handleAddTab);
    }
    disconnectedCallback() {
        if (this.listener)
            document.removeEventListener(this.listener, this.handleAddTab);
        super.disconnectedCallback();
    }
    render() {
        return html `
      <menu class="qbo-tabs">
        ${this.tabs.map((tab, index) => html `
          <li
            class="${this.activeIndex === index ? 'active' : ''}"
            @click="${() => this.setActiveTab(index)}"
          >
            ${tab.title}
          </li>
        `)}
      </menu>
       <div class="tab-content">
        ${this.tabs[this.activeIndex]?.render}
      </div>
    `;
    }
    renderActiveTab() {
        const tab = this.tabs[this.activeIndex];
        // Adding a unique key to force Lit to treat the rendered element as a new instance.
        return html `<div key="${tab.key}-${Date.now()}">${tab?.render}</div>`;
    }
    setActiveTab(index) {
        this.activeIndex = index;
        this.requestUpdate();
    }
}
__decorate([
    state(),
    __metadata("design:type", Number)
], QboTabs.prototype, "activeIndex", void 0);
__decorate([
    property({ type: Array }),
    __metadata("design:type", Array)
], QboTabs.prototype, "tabs", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboTabs.prototype, "listener", void 0);
customElements.define('qbo-tabs', QboTabs);
